import { IconProps } from '@hcs/types';

import { useIcon } from '../../../hooks';

import Add from './AddIcon.svg?react';
import Check from './CheckIcon.svg?react';
import Complete from './CompleteIcon.svg?react';
import Dash from './DashIcon.svg?react';
import Default from './DefaultIcon.svg?react';
import DotDashed from './DotDashedIcon.svg?react';
import DownArrow from './DownArrowIcon.svg?react';
import Error from './ErrorIcon.svg?react';
import Like from './LikeIcon.svg?react';
import Lock from './LockIcon.svg?react';
import Notification from './NotificationIcon.svg?react';
import Remove from './RemoveIcon.svg?react';
import Success from './SuccessIcon.svg?react';
import UpArrow from './UpArrowIcon.svg?react';

export const AddIcon = (props: IconProps) => useIcon(Add, props);
export const CheckIcon = (props: IconProps) => useIcon(Check, props);
export const CompleteIcon = (props: IconProps) => useIcon(Complete, props);
export const DashIcon = (props: IconProps) => useIcon(Dash, props);
export const DefaultIcon = (props: IconProps) => useIcon(Default, props);
export const DotDashedIcon = (props: IconProps) => useIcon(DotDashed, props);
export const DownArrowIcon = (props: IconProps) => useIcon(DownArrow, props);
export const ErrorIcon = (props: IconProps) => useIcon(Error, props);
export const SuccessIcon = (props: IconProps) => useIcon(Success, props);
export const RemoveIcon = (props: IconProps) => useIcon(Remove, props);
export const NotificationIcon = (props: IconProps) =>
  useIcon(Notification, props);
export const UpArrowIcon = (props: IconProps) => useIcon(UpArrow, props);
export const LikeIcon = (props: IconProps) => useIcon(Like, props);
export const LockIcon = (props: IconProps) => useIcon(Lock, props);
